import { render, staticRenderFns } from "./RateList.vue?vue&type=template&id=018cfd5b"
import script from "./RateList.vue?vue&type=script&lang=js"
export * from "./RateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports